module.exports = {
  "id": "fuzzy face",
  "title": "Fuzzy Face",
  "tutorialLink": "https://makeymakey.com/blogs/how-to-instructions/fuzzy-face-mouse-control-for-makey-mouse-backpack",
  "projectInfo": "Illustrations are by <a href = 'https://www.pablostanley.com/'>Pablo Stanley</a> from the <a href='https://www.openpeeps.com/'> Open Peeps</a> project. ",
  "scenes": [{
    "id": "main",
    "metadata": "main.json",
    "sb3": "fuzzy face.sb3"
  }],
  "levels": [
    "main"    
  ],
  "exposedVariables": [
    
  ],
  "startingGlitches": [
  ],
  "thumbnail": "/provision/projects/fuzzy face/fuzzy face.png",
  "category": "games",
  "toolbar":{
    "glitches":[],
    "parts":[]
  }
}
;